import type { FilterState } from "#app/lib/filters/types";

/** The advanced builder opens showing one empty row — the same seed the
 *  query resets to on clear, and the settings editor's opening state. */
export const SEEDED_EMPTY_QUERY: FilterState = {
  logic: "AND",
  blocks: [{ logic: "AND", filters: [{ field: "", operator: "eq", value: null }] }],
};
